import { Link } from "@tanstack/react-router";
import { ArrowUpRight, BookOpen, Home, ListChecks, MessageCircle, Sparkles, Wrench } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import inside from "@/assets/journal-kitchen-care.jpg";
import outside from "@/assets/journal-patio-care.jpg";

const tiles = [
  { to: "/services", icon: Sparkles, kicker: "Services", title: "Every inside & outside clean", img: inside },
  { to: "/how-it-works", icon: ListChecks, kicker: "How it works", title: "Four calm steps, no pressure", img: outside },
  { to: "/guides", icon: BookOpen, kicker: "The journal", title: "Free guides & buying advice" },
  { to: "/guides", icon: Wrench, kicker: "Product assessments", title: "Tools worth knowing about" },
  { to: "/my-property", icon: Home, kicker: "My property", title: "Save your home's details" },
] as const;

export function HomeExplore() {
  const ask = () => window.dispatchEvent(new CustomEvent("gg:ask-assistant", { detail: { question: "What does my home need this season?" } }));
  return <section className="gg-explore bws-container" aria-labelledby="gg-explore-title">
    <Reveal><div className="gg-edit-heading"><div><p className="gg-kicker">THERE'S MORE TO GROUND &amp; GLASS</p><h2 id="gg-explore-title">Keep exploring.</h2></div></div></Reveal>
    <div className="gg-explore-grid">
      {tiles.map(({ to, icon: Icon, kicker, title, ...rest }, i) => {
        const img = "img" in rest ? rest.img : undefined;
        return <Reveal key={kicker} delay={i * 60}><Link to={to} className={"gg-explore-tile" + (img ? " has-photo" : "")}>
          {img && <img src={img} alt="" loading="lazy" width={1536} height={1024} />}
          <span className="gg-explore-glass"><Icon size={18} aria-hidden /><span><small>{kicker}</small><strong>{title}</strong></span><ArrowUpRight size={18} aria-hidden /></span>
        </Link></Reveal>;
      })}
      <Reveal delay={300}><button type="button" onClick={ask} className="gg-explore-tile gg-explore-ask"><span className="gg-explore-glass"><MessageCircle size={18} aria-hidden /><span><small>Assistant</small><strong>Ask a home-care question</strong></span><ArrowUpRight size={18} aria-hidden /></span></button></Reveal>
    </div>
  </section>;
}
